import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withTracking } from '../../provider';

import CategoryBreadcrumbs from './component';

class CategoryBreadcrumbsContainer extends Component {
  getLabel = ({ labels }) => {
    if (!labels || !labels.length) {
      return '';
    }

    const locLabel = labels.find((n) => n.type === 'Location');
    if (locLabel) {
      return locLabel.value;
    }

    const distLabel = labels.find((n) => n.type === 'Distance');

    if (distLabel) {
      return distLabel.value;
    }

    return '';
  };

  render() {
    const {
      className,
      categoryData,
      renderLastLink,
      injected: {
        tracking: { trackButtonClick },
      },
    } = this.props;
    // Do not show breadcrumbs if missing category information.
    if (!categoryData) return null;

    // TODO(ryan@): Transition this to shared parent links.
    const parents = categoryData.parents
      .filter((t) => !!t.path)
      .map((t) => ({
        permalink: `/${t.path}`,
        label: this.getLabel(t),
      }))
      .reverse()
      .concat([
        {
          permalink: renderLastLink ? `/${categoryData.path}` : undefined,
          label: this.getLabel(categoryData),
        },
      ]);

    const componentProps = {
      className,
      combinedCategoryLinks: parents.length > 1 && parents,
      onClick: ({ label, permalink, index }) =>
        trackButtonClick('crumb', {
          anchorText: label,
          permalink,
          index,
        }),
    };

    return <CategoryBreadcrumbs {...componentProps} />;
  }
}

CategoryBreadcrumbsContainer.propTypes = {
  renderLastLink: PropTypes.bool,
};

CategoryBreadcrumbsContainer.defaultProps = {
  renderLastLink: false,
};

export default withTracking('breadcrumbs')(CategoryBreadcrumbsContainer);
